const FormReducer = (state, {payload, type}) => {
    switch (type) {
        case "FORM_ERROR":
            return {
                ...state,
                sending: false,
                sent: false
            }
        case "FORM_SENDING":
            return {
                ...state,
                sending: true,
                sent: false
            }
        case "FORM_SENT":
            return {
                ...state,
                sending: false,
                sent: true
            }
        case "HIDE_MODAL":
            return {
                ...state,
                sending: false,
                sent: false
            }
        default:
            return state
    }
};

export default FormReducer;
